import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../utils/AuthContext';
import { useLang } from '../utils/LanguageContext';
import { t } from '../utils/translations';
import './LoginScreen.css';

// Shown after signup, when the user has an account but no café yet:
// either create a new café (becomes owner) or join one with a team code.
function OnboardingScreen() {
  const [tab, setTab] = useState('create'); // 'create' | 'join'
  const [shopName, setShopName] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const { user, refreshProfile, signOut } = useAuth();
  const { lang, toggleLang } = useLang();
  const tr = t[lang];

  async function handleCreate(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    const { error } = await supabase.rpc('create_organization', {
      org_name: shopName,
      owner_name: user?.user_metadata?.full_name || null,
    });
    if (error) {
      setError(error.message);
    } else {
      await refreshProfile();
    }
    setBusy(false);
  }

  async function handleJoin(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    const { error } = await supabase.rpc('join_organization', {
      code,
      member_name: user?.user_metadata?.full_name || null,
    });
    if (error) {
      setError(error.message?.includes('STAFF_LIMIT') ? tr.staffLimit : tr.invalidCode);
    } else {
      await refreshProfile();
    }
    setBusy(false);
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <button type="button" className="lang-btn login-lang" onClick={toggleLang}>
          {lang === 'fr' ? 'FR' : lang === 'en' ? 'EN' : 'ع'}
        </button>

        <img className="login-logo" src={process.env.PUBLIC_URL + '/logo192.png'} alt="StratosPOS" />
        <h1 className="login-title">{tr.onboardTitle}</h1>
        <p className="login-sub">{tr.onboardSub}</p>

        <div className="onboard-tabs">
          <button
            type="button"
            className={`onboard-tab ${tab === 'create' ? 'active' : ''}`}
            onClick={() => { setTab('create'); setError(''); }}
          >{tr.createShop}</button>
          <button
            type="button"
            className={`onboard-tab ${tab === 'join' ? 'active' : ''}`}
            onClick={() => { setTab('join'); setError(''); }}
          >{tr.joinTeam}</button>
        </div>

        {tab === 'create' ? (
          <form className="onboard-form" onSubmit={handleCreate}>
            <input
              type="text"
              placeholder={tr.shopName}
              value={shopName}
              onChange={e => setShopName(e.target.value)}
              className="login-input login-input-text"
              required
              minLength={2}
            />
            <button type="submit" className="login-btn" disabled={busy}>
              {busy ? '...' : tr.create}
            </button>
          </form>
        ) : (
          <form className="onboard-form" onSubmit={handleJoin}>
            <input
              type="text"
              placeholder={tr.joinCode}
              value={code}
              onChange={e => setCode(e.target.value.toUpperCase())}
              className="login-input"
              required
            />
            <button type="submit" className="login-btn" disabled={busy}>
              {busy ? '...' : tr.join}
            </button>
          </form>
        )}

        {error && <p className="login-error">❌ {error}</p>}

        <button type="button" className="login-switch" onClick={signOut}>
          ← {user?.email}
        </button>
      </div>
    </div>
  );
}

export default OnboardingScreen;
